import { ComponentProps, FC } from 'react';

import { SvgIcon } from './SvgIcon';

export const ChevronRight: FC<ComponentProps<typeof SvgIcon>> = props => (
  <SvgIcon width="16" height="16" viewBox="0 0 16 16" {...props}>
    <path d="M6.7052 2.59104C6.31363 2.20157 5.68047 2.20327 5.29099 2.59485C4.90152 2.98642 4.90322 3.61958 5.2948 4.00905L6.7052 2.59104ZM11.027 8.30005L11.7322 9.00905C11.9209 8.82137 12.027 8.5662 12.027 8.30005C12.027 8.0339 11.9209 7.77873 11.7322 7.59104L11.027 8.30005ZM5.2948 12.591C4.90322 12.9805 4.90152 13.6137 5.291 14.0053C5.68047 14.3968 6.31363 14.3985 6.7052 14.0091L5.2948 12.591ZM5.2948 4.00905L10.3217 9.00905L11.7322 7.59104L6.7052 2.59104L5.2948 4.00905ZM10.3217 7.59104L5.2948 12.591L6.7052 14.0091L11.7322 9.00905L10.3217 7.59104Z" />
  </SvgIcon>
);
